/**
 * GuestReportLinkPage — /guest/:token/rapportera
 * Reached from the footer of every guest e-mail ("tror du att någon obehörig
 * fått länken?"). The button revokes this link and e-mails a new one; nothing
 * happens on load. An already replaced link is told to request its current
 * link instead (the refusal re-routes to that parked page).
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { guestApi } from '../../api/guestApi';
import { GuestInvalidLinkPage, GuestSelfServicePage } from './components/GuestLinkStatePages';

const GuestReportLinkPage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    if (!token) return <GuestInvalidLinkPage />;

    return (
        <GuestSelfServicePage
            token={token}
            icon={<ShieldAlert size={48} className="text-danger mb-3" />}
            title="Spärra länken och få en ny"
            text="Om du tror att någon obehörig fått tillgång till din länk kan du spärra den här. Den gamla länken slutar fungera direkt och en ny skickas till din e-postadress."
            buttonLabel="Spärra och skicka ny länk"
            action={() => guestApi.reportLink(token).then(({ maskedEmail, newLinkSent }) => (newLinkSent
                ? `Länken är spärrad. En ny länk är skickad till ${maskedEmail}.`
                : `Länken är spärrad. Du har inga aktiva uppgifter just nu; när förvaltaren delegerar något till dig får du en ny länk till ${maskedEmail}.`))}
        />
    );
};

export default GuestReportLinkPage;
